import React from "react"
import { Scorer } from "../../models/Scorer"
import { TwitchUser } from "../../models/TwitchUser"
import { openTwitch } from "../../models/Utils"
import { Router } from "../../utils/Router"
import { UserReader } from "../../utils/UserReader"
import { Loader } from "./Loader"

interface IProps{
    readonly position: number
    readonly user: Scorer
}

export class UserCard extends UserReader<IProps, Partial<TwitchUser>>{
    afterRead = (user: TwitchUser) => this.setState(user)
    
    getUsername = () => this.props.user.username
    
    orLoading = (item: string | number) => item == null ? <Loader /> : item

    render = () => {
        const { profile_image_url, display_name, description } = this.state,
        { user, position } = this.props,
        { points, aQuestions, username } = user

        return <div key={username} className="top-scorer-card shadow" onClick={() => openTwitch(username)}>
            <div className="scorer-card-header">
                <span className="position">#{position}</span>
                <img src={profile_image_url || Router.getBaseUrl() + "images/default_user.png"} alt={"user-avatar_" + username} />
                <div className="scorer-card-info">
                    <span>{this.orLoading(display_name)}</span>
                    <span>@{username}</span>
                </div>
            </div>
            <div className="scorer-card-content">
                <small>{description || "Nessuna descrizione"}</small>

                <div className="scores">
                    <div>
                        <span>Punti</span>
                        <span>{this.orLoading(points)}</span>
                    </div>
                    <div>
                        <span>Risposte</span>
                        <span>{this.orLoading(aQuestions)}</span>
                    </div>
                </div>
            </div>
        </div>
    }
}